import { Component, ViewChild, ElementRef, OnInit } from '@angular/core';
import { COMMA, ENTER } from '@angular/cdk/keycodes';
import { HttpClient } from '@angular/common/http';
import { IPDRegistrationModel } from '../models/ipdRegistration';
import { AuthService } from 'app/auth/auth.service';
import { DashboardService } from 'app/dashboard/dashboard.service';
import { DatePipe } from '@angular/common';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { OpdVisitService } from 'app/opdvisits/Services/OpdVisit.service';
import { ActivatedRoute, Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { BillingserviceService } from 'app/billing/billingService.service';
import { LanguageService } from 'app/shared/language.service';
import { IPDService } from '../Services/ipdServices.service';
import { takeUntil } from 'rxjs/operators';
import { Subject } from 'rxjs';
import { SearchDialogComponent } from 'app/table-list/Searchdialog/SearchDialoag.component';
import { SearchIpdPatientComponent } from '../search-ipd-patient/search-ipd-patient.component';
import { AddmissionPackageComponent } from '../add-service/add-service.component';
import { PatientDocumentComponent } from '../patient-document/patient-document.component';
import { FormControl } from '@angular/forms';
import { startWith } from 'rxjs/operators/startWith';
import { map } from 'rxjs/operators/map';
import { interval, Observable } from 'rxjs';
import { SiteloaderComponent } from 'app/auth/siteloader/siteloader.component';
import { DynamicHelpListComponent } from 'app/EMR/Doctor/doctor-other-info/dynamic-help-list/dynamic-help-list.component';
import * as moment from 'moment';
import { CorporateDetailComponent } from 'app/billing/corporate-detail/corporate-detail.component';
import { OTConsentComponent } from '../otconsent/otconsent.component';
@Component({
  selector: 'app-ipd-registration',
  templateUrl: './ipd-registration.component.html',
  styleUrls: ['./ipd-registration.component.scss']
})


export class IpdRegistrationComponent implements OnInit {

  //  private format = 'CODE39';
  //  private lineColor = '#000000';
  //  private width = 1;
  //  private height = 15;
  //  private displayValue = false;
  //  private fontOptions = '';
  //  private font = 'monospace';
  //  private textAlign = 'center';
  //  private textPosition = 'bottom';
  //  private textMargin = 2;
  //  private fontSize = 10;
  //  private background = '#ffffff';
  //  private margin = 10;
  //  private marginTop = 5;
  //  private marginBottom = 5;
  //  private marginLeft = 10;
  //  private marginRight = 10;
  destroy$: Subject<boolean> = new Subject<boolean>();
  IpdRegistrationModel: IPDRegistrationModel = {};
  private WardListArray: any = [];
  private DoctorListArray: any = [];
  private PackageListArray: any = [];
  private UpgradePackageListArray: any = [];
  private IPDTypeListArray: any = [];
  private PatientObj: any = {};
  private screenPermissionobj: any = {};
  private PatinetName: string;
  private totalAmount: number;
  private totalupgradedAmount: number;
  private totaldifferenceAmount: number;
  private rowClicked: any;
  private externalDoctorArray: any = [];
  private bookingobj: any = [];
  private allPackageList: any = [];
  private getRateTypeVal: string;
  private isdisable: boolean;
  private checkIpdPatient: any;
  private ShowPartyName: any;
  private PartyCtrl: FormControl;
  private filteredPartyArray: Observable<any[]>;
  private ShowReferdByName: any;
  private ReferedbyCtrl: FormControl;
  private filteredReferedbyArray: Observable<any[]>;
  private ShowCateName: any;
  private CatCtrl: FormControl;
  private bedCtrl: FormControl;
  private filteredCatArray: Observable<any[]>;
  private filteredbedArray: Observable<any[]>;
  private ShowDoctorName: any;
  private DoctorCtrl: FormControl;
  private filteredDoctorArray: Observable<any[]>;
  private ShowDoctorName2: any;
  private roomcategoryName: any;
  private DoctorCtrl2: FormControl;
  private filteredDoctor2Array: Observable<any[]>;
  private RoomCategory: FormControl;
  private filteredRoomArray: Observable<any[]>;
  private partyName: string = '';
 // private url = '';
  private mainUrl: string;
  private documentrul: any;
  private patientbarcodecheck: boolean = false;
  private patientregistrikerprint: boolean = false;
  private patientID: any;
  // private stickerarray: any = [];
  private bookingtype: boolean = false;
  private MinimeDate: string;
  private bedinfodata: any;
  private roomCategoryName: any;
  private fromDate: string;
  private fromTime: any;
  private ToDate: string;
  private ToTime: any;
  private Otconsentdata: any;
  private PageHeader: any = {};
  private reporturl: string;
  private headerChecked: boolean;
  private ipdId: number;
  // Warddata: any;
  constructor(public http: HttpClient, public authService: AuthService,
    public dashboardService: DashboardService,
    private datePipe: DatePipe,
    public opdvisitService: OpdVisitService,
    public dialog: MatDialog,
    public router: Router,
    public translate: TranslateService,
    public langservice: LanguageService,
    public billingservice: BillingserviceService,
    public ipdService: IPDService,
    private route: ActivatedRoute
    // public dialogRef: MatDialogRef<BillingComponent>
  ) {
    this.getalldata();

  }


  ngOnInit(): void {
    this.opdvisitService.callsepecificApi = 'ALL';
    this.bookingtype = false;
    this.IpdRegistrationModel = {};
    this.PatientObj = {};
    this.PackageListArray = [];
    this.UpgradePackageListArray = [];
    this.totalAmount = 0;
    this.totalupgradedAmount = 0;
    this.totaldifferenceAmount = 0;
    this.rowClicked = 1;
    this.bookingobj = [];
    this.IpdRegistrationModel.MLC = false;
    this.IpdRegistrationModel.IsOneEyed = false;
    this.screenPermissionobj = {};
    this.IpdRegistrationModel.surgerydate = this.datePipe.transform(this.authService.localDate, "yyyy-MM-dd");
    this.getRateTypeVal = 'RateGeneral';
    this.PatinetName = 'Patient Name';
    this.isdisable = false;
    this.getscreenPermission();
    this.ShowReferdByName = '';
    this.ShowDoctorName = '';
    this.ShowDoctorName2 = '';
    this.roomcategoryName = '';
    this.ShowCateName = '';
    this.ShowPartyName = '';
    this.patientID = null;
    this.get_patient_docurl();
    this.MinimeDate = moment(new Date(this.authService.getServerDate)).format('YYYY-MM-DD');
    // this.stickerarray = [{ a: 1 }, { a: 1 }, { a: 1 }, { a: 1 }, { a: 1 }, { a: 1 }, { a: 1 }, { a: 1 }, { a: 1 }, { a: 1 }, { a: 1 }, { a: 1 }, { a: 1 }, { a: 1 }, { a: 1 }, { a: 1 }]
    this.getOtConsent();
  }
  ngOnDestroy(): void {
    this.destroy$.next(true);
    this.destroy$.unsubscribe();
    this.MinimeDate = null;
    this.ShowPartyName = null;
    this.ShowCateName = null;
    this.roomcategoryName = null;
    this.ShowDoctorName2 = null;
    this.ShowDoctorName = null;
    this.ShowReferdByName = null;
    this.isdisable = null;
    this.PatinetName = null;
    this.getRateTypeVal = null;
    this.IpdRegistrationModel.surgerydate = null;
    this.screenPermissionobj = null;
    this.IpdRegistrationModel.IsOneEyed = null;
    this.IpdRegistrationModel.MLC = null;
    this.bookingobj = null;
    this.rowClicked = null;
    this.totaldifferenceAmount = null;
    this.totalupgradedAmount = null;
    this.totalAmount = null;
    this.totalAmount = null;
    this.UpgradePackageListArray = null;
    this.PackageListArray = null;
    this.PatientObj = null;
    this.IpdRegistrationModel = null;
    this.bookingtype = null;

  }
  validateNo(e: any): boolean {
    const charCode = e.which ? e.which : e.keyCode;
    if (charCode > 31 && (charCode < 48 || charCode > 57)) {
      return false
    }
    return true
  }
  refreshPage() {
    this.ShowDoctorName = '';
    this.ShowDoctorName2 = '';
    this.roomcategoryName = '';
    this.ShowReferdByName = null;
    // this.roomcategoryName = 'General';
    this.ShowCateName = null;
    this.partyName = '';
    this.patientID = null;
    this.totaldiscount = 0;
    this.opdvisitService.url = '';
    this.seravicedata = [];
    this.bedinformationArray = [];
    this.bedinfodata = [];
    this.getalldata();
    this.ngOnInit();
  }

  getalldata() {
    this.getRoomCategoryMaster();
    this.opdvisitService.getpersonmaster('IPDREGISTRATION', 0);
    this.getwardlist();
    this.GetRateType();
    this.getPartTpa();
    this.getalluserlist();
    this.getAllPackageList();
    this.getTypeIdp();

    this.getproductmasterconfig();

    this.partyControll();
    this.referedbyControll();
    this.categoryControll();
    this.roomCategoryController();
    this.doctorControll();
    this.doctorControll2();
    //  this.setDefailtsomeFields();
    this.setfreshIpdRegistrationForm();
  }

  setDefailtsomeFields() {


    this.DoctorListArray?.forEach(item => {
      if (item.userId == this.DoctorListArray[0].userId) {
        this.ShowDoctorName = item.userName;
        this.ShowDoctorName2 = item.userName;
        this.IpdRegistrationModel.FK_ConsultantId = item.userId;
        this.IpdRegistrationModel.FK_ConsultantID2 = item.userId;
      }
    });

    this.billingservice.partytpa?.forEach(item => {
      if (item.pkPartyId == this.billingservice.partytpa[0].pkPartyId) {
        this.ShowPartyName = item.partyName;
        this.IpdRegistrationModel.FK_PartyId = item.pkPartyId;
      }

    })

    this.opdvisitService.personmaster?.forEach(item => {
      if (item.pkPersonId == this.opdvisitService.personmaster[0].pkPersonId) {
        this.ShowReferdByName = item.personName;
        this.IpdRegistrationModel.FK_ReferedById = item.pkPersonId;
      }

    })

    this.dashboardService.categories?.forEach(item => {
      if (item.pkCategoryId == this.dashboardService.categories[0].pkCategoryId) {
        this.IpdRegistrationModel.FK_CategoryId = this.dashboardService.categories[0]?.pkCategoryId;
        this.ShowCateName = item.categoryName;
      }

    })

    // this.categoryRoomArray.forEach(item => {
    //   if (item.pK_RoomCategoryId == this.categoryRoomArray[0].pK_RoomCategoryId)
    //     this.IpdRegistrationModel.fK_RoomCategoryId = this.categoryRoomArray[0]?.pK_RoomCategoryId;
    //   this.roomcategoryName = this.categoryRoomArray[0]?.roomCategory;
    // })


  }

  WardListArrayfull: any;
  getwardlist() {

    this.ipdService.getWardList().pipe(takeUntil(this.destroy$)).subscribe(data => {
      this.WardListArrayfull = [];
      this.WardListArray = [];
      this.WardListArrayfull = data;
      // console.log(this.WardListArray)
      this.WardListArray = data.filter(item => item.fK_RoomCategoryId == this.IpdRegistrationModel.fK_RoomCategoryId && item.fK_BranchId == this.authService.Loggeduser.branchid && (item.fK_IPDID == 0 || item.fK_IPDID == null));

      this.wardControll();
    })
  }
  bedinformation: boolean = false;
  bedinfobyWard(warddata, value) {
    this.bedinformation = true;
    this.bedinfodata = warddata.filter(item => item.pK_RoomId == value);
    var roomcategory = this.categoryRoomArray.filter(item => item.pK_RoomCategoryId == this.bedinfodata[0].fK_RoomCategoryId);
    this.roomCategoryName = roomcategory[0].roomCategory;
    this.authService.getServertime();
    this.fromDate = moment(new Date(this.authService.getServerDate)).format('YYYY-MM-DD');
    this.fromTime = moment(this.authService.serverTime, ["HH:mm"]).format("h:mm A");

  }
  GetRateType() {
    this.billingservice.get_rate_typelist().pipe(takeUntil(this.destroy$)).subscribe((data: any[]) => {
      this.billingservice.ratetype = data;
      //  console.log('billingservice.ratetype',data)
    })
  }


  partyControll() {

    this.PartyCtrl = new FormControl();
    this.filteredPartyArray = this.PartyCtrl.valueChanges
      .pipe(
        startWith(''),
        map(cat => cat ? this.filterpartyfunction(cat) : this.billingservice.partytpa.slice())
      );
  }

  filterpartyfunction(name: string) {
    return this.billingservice.partytpa.filter(party =>
      party.partyName.toLowerCase().indexOf(name.toLowerCase()) === 0);
  }

  getPartyobj(e: any) {
    let partyId = e.option.id;
    this.IpdRegistrationModel.FK_PartyId = partyId;
  }

  referedbyControll() {
    this.ReferedbyCtrl = new FormControl();
    this.filteredReferedbyArray = this.ReferedbyCtrl.valueChanges
      .pipe(
        startWith(''),
        map(cat => cat ? this.filterReferedbyfunction(cat) : this.opdvisitService.personmaster.slice())
      );
  }
  newPersonArray: any = []
  filterReferedbyfunction(name: string) {
    // return this.opdvisitService.personmaster.filter(country =>
    //   country.personName?.toLowerCase().indexOf(name.toLowerCase()) === 0);
    if (name != null && name != undefined) {
      const filterValue = name.toLowerCase();
      const returndata = this.opdvisitService.personmaster.filter(country =>
        country.personName?.toLowerCase().indexOf(filterValue) === 0);
      if (returndata.length == 0 && name.length >= 3) {
        this.opdvisitService.getpersonMasterSpecific('IPDREGISTRATION', name).pipe(takeUntil(this.destroy$)).subscribe((x: any) => {
          this.newPersonArray = [];
          this.newPersonArray = x;
          this.filteredReferedbyArray = this.ReferedbyCtrl.valueChanges
            .pipe(
              startWith(''),
              map(cat => this.newPersonArray.slice())
            );
        })
      } else {
        return returndata;
      }
    }

  }
  CheckinputDoctor(event: any) {

    var checkdata = event.target.value;
    if (checkdata == "") {
      this.referedbyControll();
      this.IpdRegistrationModel.FK_ReferedById = null;

    }
  }
  getreferedbyobj(e: any) {
    let refId = e.option.id;
    this.IpdRegistrationModel.FK_ReferedById = refId;
  }


  wardControll() {
    this.bedCtrl = new FormControl();
    this.filteredbedArray = this.bedCtrl.valueChanges
      .pipe(
        startWith(''),
        map(cat => cat ? this.filterbedfunction(cat) : this.WardListArray.slice())
      );
  }
  filterbedfunction(name: string) {
    return this.WardListArray.filter(country =>
      country.roomName.toLowerCase().indexOf(name.toLowerCase()) === 0);
  }

  categoryControll() {
    this.CatCtrl = new FormControl();
    this.filteredCatArray = this.CatCtrl.valueChanges
      .pipe(
        startWith(''),
        map(cat => cat ? this.filtercategoryfunction(cat) : this.dashboardService.categories.slice())
      );
  }
  filtercategoryfunction(name: string) {
    return this.dashboardService.categories.filter(country =>
      country.categoryName.toLowerCase().indexOf(name.toLowerCase()) === 0);
  }

  getcategoryobj(e: any) {
    let pkCategoryId = e.option.id;
    this.IpdRegistrationModel.FK_CategoryId = pkCategoryId;
  }
  getwardbedobj(e: any) {
    let pkCategoryId = e.option.id;
    this.IpdRegistrationModel.FK_WardID = pkCategoryId;
    this.IpdRegistrationModel.RoomName = e.option.value;
    this.bedinfobyWard(this.WardListArray, this.IpdRegistrationModel.FK_WardID);
  }

  doctorControll() {
    this.DoctorCtrl = new FormControl();
    this.filteredDoctorArray = this.DoctorCtrl.valueChanges
      .pipe(
        startWith(''),
        map(cat => cat ? this.filterdoctorfunction(cat) : this.DoctorListArray.slice())
      );
  }

  filterdoctorfunction(name: string) {
    return this.DoctorListArray.filter(country =>
      country.userName.toLowerCase().indexOf(name.toLowerCase()) === 0);
  }

  getdoctorobj(e: any) {
    let constID = e.option.id;
    this.IpdRegistrationModel.FK_ConsultantId = constID;
  }
  seravicedata: any = [];
  stotalAmount: number = 0;
  stotaldiscount: number = 0;
  GetCounselorAdditionalService(ratetye, counlerid, type) {
    this.stotalAmount = 0;
    this.stotaldiscount = 0;
    this.ipdService.GetCounselorAdditionalService(counlerid).pipe(takeUntil(this.destroy$)).subscribe((x: any) => {
      this.seravicedata = [];
      if (x.length > 0) {
        this.seravicedata = x;
        this.seravicedata.forEach(item => {
          if (ratetye == 1) {
            this.stotalAmount = this.stotalAmount + parseInt(item.amount);
            let percetaageamount = (parseInt(item.amount) * parseInt(item.discountPer)) / 100;
            this.stotaldiscount = this.stotaldiscount + percetaageamount;
          } else if (ratetye == 2) {
            this.stotalAmount = this.stotalAmount + parseInt(item.spAmount);
            let percetaageamount = (parseInt(item.spAmount) * parseInt(item.discountPer)) / 100;
            this.stotaldiscount = this.stotaldiscount + percetaageamount;
          } else if (ratetye == 3) {
            this.stotalAmount = this.stotalAmount + parseInt(item.pAmount);
            let percetaageamount = (parseInt(item.pAmount) * parseInt(item.discountPer)) / 100;
            this.stotaldiscount = this.stotaldiscount + percetaageamount;
          } else if (ratetye == 4) {
            this.stotalAmount = this.stotalAmount + parseInt(item.sdAmount);
            let percetaageamount = (parseInt(item.sdAmount) * parseInt(item.discountPer)) / 100;
            this.stotaldiscount = this.stotaldiscount + percetaageamount;
          } else if (ratetye == 5) {
            this.stotalAmount = this.stotalAmount + parseInt(item.dAmount);
            let percetaageamount = (parseInt(item.dAmount) * parseInt(item.discountPer)) / 100;
            this.stotaldiscount = this.stotaldiscount + percetaageamount;
          }

        });

      }
      if (this.IpdRegistrationModel.PK_IPDId > 0 && type > 0) {
        this.setpackageforUpdate(this.IpdRegistrationModel.PK_IPDId);
      } else {
        this.setbookingpackaged(ratetye, counlerid);
      }


    });
  }

  doctorControll2() {
    this.DoctorCtrl2 = new FormControl();
    this.filteredDoctor2Array = this.DoctorCtrl2.valueChanges
      .pipe(
        startWith(''),
        map(cat => cat ? this.filterdoctor2function(cat) : this.DoctorListArray.slice())
      );
  }

  filterdoctor2function(name: string) {
    return this.DoctorListArray.filter(country =>
      country.userName.toLowerCase().indexOf(name.toLowerCase()) === 0);
  }

  roomCategoryController() {
    this.RoomCategory = new FormControl();

    this.filteredRoomArray = this.RoomCategory.valueChanges
      .pipe(
        startWith(''),
        map(cat => cat ? this.filterroomfunction(cat) : this.categoryRoomArray.slice())
      );
    console.log(this.filteredRoomArray);
  }

  filterroomfunction(name: string) {
    return this.categoryRoomArray.filter(country =>
      country.roomCategory.toLowerCase().indexOf(name.toLowerCase()) === 0);
  }
  getdoctorobj2(e: any) {
    let constID2 = e.option.id;
    this.IpdRegistrationModel.FK_ConsultantID2 = constID2;
  }
  getroomobj2(e: any) {

    let roomID2 = e.option.id;
    this.IpdRegistrationModel.fK_RoomCategoryId = roomID2;
    this.getwardlist();
  }
  getproductmasterconfig() {
    let BranchId = this.authService.Loggeduser.branchid;
    this.billingservice.getproductionConfrigration(BranchId).pipe(takeUntil(this.destroy$)).subscribe(data => {
      console.log('master confrigartion', data);
      const urldate = data.filter(item => item.propertyName == 'WebURL');

      const pageheader = data.filter(item => item.propertyName == 'PageHeadWebReport');

      const checktrue = pageheader[0]?.propertyValue;
      this.PageHeader = checktrue;
      const url = urldate[0].propertyValue;
      this.reporturl = url;
      for (let i = 0; i < data.length; i++) {
        const element = data[i];
        if (element.propertyName === "SingleIPDRegistration_YN") {
          this.checkIpdPatient = element.propertyValue;
          console.log(this.checkIpdPatient)
        }
      }
    })
  }

  getPartTpa() {
    this.billingservice.get_partytpa().pipe(takeUntil(this.destroy$)).subscribe(data => this.success_partytpa(data), err => this.failed_partytpa(err));
  }
  success_partytpa(data) {
    this.billingservice.partytpa = data;

  }
  failed_partytpa(err) {
    if (err.status == 403) {
        this.dashboardService.openSnackBar("You Don't have Permission", "OK");
      } else if (err.error.statusCode == 422) {
        this.dashboardService.openSnackBar(err.error.message, "OK");
      } else {
        this.dashboardService.openSnackBar("API Failed", "OK");
      }
  }

  onupdateAmount(e: number, index: number, check: string) {
    if (e === null || e === undefined) { }
    else {
     // this.PackageListArray[index].discountPer = 0;
      this.PackageListArray[index].amount = e;
      this.paymentDetail(this.PackageListArray, 'normal');

    }
  }
  totaldiscount: any = 0;
  onupdateDiscount(e: number, index: number, check: string) {


    if (e === null || e === undefined) {
      this.PackageListArray[index].discountPer = 0;
    }
    else {
      if ((e >= 0) && (e <= 100)) {
        this.PackageListArray[index].discountPer = e;
        this.paymentDetail(this.PackageListArray, 'normal');
      } else {
        this.PackageListArray[index].discountPer = 0;
        this.paymentDetail(this.PackageListArray, 'normal');
        this.dashboardService.openSnackBar("Please Enter Percentage 0 to 100 ", "OK");
      }


    }
  }
  paymentDetail(data, check: string) {

    this.totalupgradedAmount = 0;
    if (this.IpdRegistrationModel.PK_IPDId === 0) {
      if (check === 'normal') {
        this.totalAmount = 0;
        this.totaldiscount = 0;
        data?.forEach(element => {
          if (element.amount) {
            this.totalAmount = (this.totalAmount) + parseInt(element.amount);
            if (element.discountPer > 0) {
              const discountAmount = (parseInt(element.amount) * parseInt(element.discountPer)) / 100;
              this.totaldiscount = parseInt(this.totaldiscount) + parseInt(discountAmount.toFixed(2));
            }
          }
          else if (element.amount) {
            this.totalAmount = this.totalAmount + parseInt(element.amount);
            if (element.discountPer > 0) {
              const discountAmount = (parseInt(element.amount) * parseInt(element.discountPer)) / 100;
              this.totaldiscount = parseInt(this.totaldiscount) + parseInt(discountAmount.toFixed(2));
            }
          }
        });
        this.totalAmount = (this.totalAmount + this.stotalAmount);
        this.totaldiscount = parseInt(this.totaldiscount) + this.stotaldiscount;
      }
      else if (check === 'upgrade') {
        this.totaldifferenceAmount = 0;
        data?.forEach(element => {
          if (element.amount) {
            this.totaldifferenceAmount = this.totaldifferenceAmount + parseInt(element.amount)
          }
          else if (element.amount) {
            this.totaldifferenceAmount = this.totaldifferenceAmount + parseInt(element.amount)
          }

        })

      }

      if (this.totaldifferenceAmount > this.totalAmount) {
        this.totalupgradedAmount = this.totaldifferenceAmount - this.totalAmount;
      }
    }

    else if (this.IpdRegistrationModel.PK_IPDId > 0) {
      this.totalAmount = 0
      this.totaldiscount = 0;
      this.PackageListArray?.forEach(element => {
        this.totalAmount = this.totalAmount + parseInt(element.amount);
        if (element.discountPer > 0) {
          const discountAmount = (parseInt(element.amount) * parseInt(element.discountPer)) / 100;
          this.totaldiscount = parseInt(this.totaldiscount) + parseInt(discountAmount.toFixed(2));
        }
      });
      this.totalAmount = (this.totalAmount + this.stotalAmount);
      this.totaldiscount = parseInt(this.totaldiscount) + this.stotaldiscount;
      this.totaldifferenceAmount = 0;
      this.UpgradePackageListArray?.forEach(element => {
        this.totaldifferenceAmount = this.totaldifferenceAmount + parseInt(element.amount)
      })
      if (this.totaldifferenceAmount > this.totalAmount) {
        this.totalupgradedAmount = this.totaldifferenceAmount - this.totalAmount;
      }

    }



  }

  onupdateTotalAmount(e: number) {
    this.totalAmount = e;
    this.totalupgradedAmount = this.totaldifferenceAmount - this.totalAmount;

  }

  getAllPackageList() {
    var id = 1
    var date = this.dashboardService.selecteddate;
    this.ipdService.GetpackageList(this.getRateTypeVal, id, date).pipe(takeUntil(this.destroy$)).subscribe(data => {
      this.allPackageList = data;
      //  console.log('package', this.allPackageList);
    }, err => {
     if (err.status == 403) {
        this.dashboardService.openSnackBar("You Don't have Permission", "OK");
      } else if (err.error.statusCode == 422) {
        this.dashboardService.openSnackBar(err.error.message, "OK");
      } else {
        this.dashboardService.openSnackBar("API Failed", "OK");
      }
    })
  }

  selectedUpgradePackage(value: number, index: number) {
    var obj: any;
    //  console.log(value,obj, this.UpgradePackageListArray)
    for (let i = 0; i < this.allPackageList.length; i++) {
      if (this.allPackageList[i].pK_PackageId == value) {
        obj = this.allPackageList[i];
      }
    }

    // console.log(value,obj);
    this.UpgradePackageListArray[index].packageName = obj.packageName;
    this.UpgradePackageListArray[index].amount = obj.packageAmount;
    this.UpgradePackageListArray[index].fK_PackageId = obj.pK_PackageId;
    this.paymentDetail(this.UpgradePackageListArray, 'upgrade')

  }


  selectedNormalPackage(value: number, index: number) {
    var obj: any;
    // console.log(value,obj, this.PackageListArray)
    for (let i = 0; i < this.allPackageList.length; i++) {
      if (this.allPackageList[i].pK_PackageId == value) {
        obj = this.allPackageList[i];
      }
    }

    //  console.log(value,obj);
    this.PackageListArray[index].packageName = obj.packageName;
    this.PackageListArray[index].amount = obj.packageAmount;
    this.PackageListArray[index].fK_PackageId = obj.pK_PackageId;
    this.paymentDetail(this.PackageListArray, 'normal')

  }

  changeSelectedRateType(value) {

    console.log(value);
    for (let i = 0; i < this.billingservice.ratetype.length; i++) {
      var obj: any = {};
      if (this.billingservice.ratetype[i].rateTypeId == value) {
        obj = this.billingservice.ratetype[i];
        this.IpdRegistrationModel.RateType = obj.rateTypeId;
        this.getRateTypeVal = obj.rateType;
      }

    }

  }
  oldPackageData: any = [];
  reloadPackageData() {

    this.oldPackageData = [];
    if (this.bookingtype == true && this.IpdRegistrationModel.FK_ConsId > 0) {
      this.oldPackageData = this.PackageListArray;
      this.GetCounselorAdditionalService(this.IpdRegistrationModel.RateType, this.IpdRegistrationModel.FK_ConsId, 0);
    }
  }


  addService(type) {
    console.log(this.IpdRegistrationModel.FK_RegId);
    if (this.IpdRegistrationModel.FK_RegId > 0) {
      this.ipdService.selectedServiceRow = [];
      const dialogRef = this.dialog.open(AddmissionPackageComponent, {
        panelClass: "full-width-dialog",
        maxWidth: "60vw",
        // height: "80%",
        width: "100%",
        data: { id: this.IpdRegistrationModel.FK_PartyId, Type: this.getRateTypeVal }
      });



      dialogRef.afterClosed().pipe(takeUntil(this.destroy$)).subscribe(result => {

        if (this.IpdRegistrationModel.PK_IPDId > 0) {
          var Result: any = [];
          if (type === 'normal') {
            Result = this.ipdService.selectedServiceRow;
            Result?.forEach(element => {
              this.PackageListArray.push({ "pK_TranId": 0, "fK_IPDId": this.IpdRegistrationModel.PK_IPDId, "fK_PackageId": element.pK_PackageId, "discountPer": element.discountPer ? element.discountPer : null, "FK_ConsID": null, "amount": element.packageAmount, "packageName": element.packageName })
            });

            this.PackageListArray = this.PackageListArray?.reduce((unique, o) => {
              if (!unique.some(obj => obj.packageName === o.packageName && obj.packageAmount === o.packageAmount)) {
                unique.push(o);
              }
              return unique;
            }, []);

            // console.log('selected service',   this.PackageListArray);
            this.paymentDetail(this.PackageListArray, 'normal')
          }

          else if (type === 'upgrade') {
            Result = this.ipdService.selectedServiceRow;

            Result?.forEach(element => {
              this.UpgradePackageListArray.push({ "pK_TranId": 0, "fK_IPDId": this.IpdRegistrationModel.PK_IPDId, "fK_PackageId": element.pK_PackageId, "amount": element.packageAmount, "FK_ConsID": null, packageName: element.packageName })
            });

            this.UpgradePackageListArray = this.UpgradePackageListArray?.reduce((unique, o) => {
              if (!unique.some(obj => obj.packageName === o.packageName && obj.packageAmount === o.packageAmount)) {
                unique.push(o);
              }
              return unique;
            }, []);

            // console.log('selected service',  this.UpgradePackageListArray);
            this.paymentDetail(this.UpgradePackageListArray, 'upgrade')
          }

        }
        else if (this.IpdRegistrationModel.PK_IPDId === 0) {

          if (type === 'normal') {
            Result = this.ipdService.selectedServiceRow;
            Result?.forEach(element => {
              this.PackageListArray.push({ "pK_TranId": 0, "fK_IPDId": this.IpdRegistrationModel.PK_IPDId, pK_PackageId: element.pK_PackageId, "amount": element.packageAmount, packageName: element.packageName })
            });

            this.PackageListArray = this.PackageListArray?.reduce((unique, o) => {
              if (!unique.some(obj => obj.packageName === o.packageName && obj.packageAmount === o.packageAmount)) {
                unique.push(o);
              }
              return unique;
            }, []);
            // console.log('selected service', this.PackageListArray);
            this.paymentDetail(this.PackageListArray, 'normal')

          }
          else if (type === 'upgrade') {
            Result = this.ipdService.selectedServiceRow;
            Result?.forEach(element => {
              this.UpgradePackageListArray.push({ "pK_TranId": 0, "fK_IPDId": this.IpdRegistrationModel.PK_IPDId, pK_PackageId: element.pK_PackageId, "amount": element.packageAmount, "FK_ConsID": null, packageName: element.packageName })
            });

            this.UpgradePackageListArray = this.UpgradePackageListArray?.reduce((unique, o) => {
              if (!unique.some(obj => obj.packageName === o.packageName && obj.packageAmount === o.packageAmount)) {
                unique.push(o);
              }
              return unique;
            }, []);

            // console.log('selected service', this.UpgradePackageListArray);
            this.paymentDetail(this.UpgradePackageListArray, 'upgrade')
          }

        }
      });
    } else {
      this.dashboardService.openSnackBar("Please Select Patient", "OK");
    }
  }
  //getexternal docotor
  getalluserlist() {

    this.billingservice.getallUsers().pipe(takeUntil(this.destroy$)).subscribe(data => {
      var result = data.filter(docUser => docUser.fkUserTypeId === 6);
      this.externalDoctorArray = result.filter(docUser => docUser.isExternal === true);
      this.getDoctorBrach();
    })
  }

  //get schedule type
  getDoctorBrach() {
    this.dashboardService.getall_doctors().pipe(takeUntil(this.destroy$)).
      subscribe(data => this.success_doctors(data), err => this.failed_doctors(err));
  }

  success_doctors(data) {
    //  console.log('doctores',data);


    if (this.authService.masterdata.isExternal === true) {
      if (this.externalDoctorArray.length > 0) {
        for (let i = 0; i < this.externalDoctorArray.length; i++) {
          const element = this.externalDoctorArray[i];
          this.opdvisitService.doctors = data.filter(ar => !this.externalDoctorArray.find(rm => (rm.pkUserId === ar.userId && ar.userName === rm.loginName)))
          this.DoctorListArray = this.opdvisitService.doctors;
          this.IpdRegistrationModel.FK_ConsultantId = this.DoctorListArray[0]?.userId;
          this.IpdRegistrationModel.FK_ConsultantID2 = this.DoctorListArray[0]?.userId;
        }
      }
      else {
        this.DoctorListArray = data;
        this.IpdRegistrationModel.FK_ConsultantId = this.DoctorListArray[0]?.userId;
        this.IpdRegistrationModel.FK_ConsultantID2 = this.DoctorListArray[0]?.userId;


      }
    } else {
      this.DoctorListArray = data;
      this.IpdRegistrationModel.FK_ConsultantId = this.DoctorListArray[0]?.userId;
      this.IpdRegistrationModel.FK_ConsultantID2 = this.DoctorListArray[0]?.userId;

    }
    this.doctorControll();
    this.doctorControll2();
    this.setDefailtsomeFields();


  }
  failed_doctors(err) {
   if (err.status == 403) {
        this.dashboardService.openSnackBar("You Don't have Permission", "OK");
      } else if (err.error.statusCode == 422) {
        this.dashboardService.openSnackBar(err.error.message, "OK");
      } else {
        this.dashboardService.openSnackBar("API Failed", "OK");
      }
  }


  // getOTcontatList(){
  //   this.ipdService.getOTContent().subscribe(data=>{
  //     this.OTconstentListArray = data;
  //     console.log('ot constent',data)
  //   })
  // }

  getbookingdata() {
    this.bookingtype = false;
    // this.ngOnInit();
  }
  categoryRoomArray: any = [];
  getRoomCategoryMaster() {
    this.ipdService.getRoomCategoryMaster(this.authService.Loggeduser.specialityId).pipe(takeUntil(this.destroy$)).subscribe((x: any) => {
      this.categoryRoomArray = [];
      this.categoryRoomArray = x.filter(item => item.isActive == true);
      if (this.categoryRoomArray.length > 0) {
        this.IpdRegistrationModel.fK_RoomCategoryId = this.categoryRoomArray[0]?.pK_RoomCategoryId;
      } else {
        this.IpdRegistrationModel.fK_RoomCategoryId = 1;
      }


      this.roomCategoryController();
    });
  }
  getbookingdatanew(id: number) {

    if (id) {

      this.bookingobj = [];
      this.ipdService.getIpdbookingData(id).pipe(takeUntil(this.destroy$)).subscribe(data => {
        this.bookingobj = data?.filter(item => item.surgeryStatus == 'Booked');
        if (this.bookingobj.length > 0) {
          document.getElementById("BillingResonModel").style.display = "block";
        } else {
          this.dashboardService.openSnackBar("Record Not Found", "OK");
        }

      })
    }
    else {
      this.dashboardService.openSnackBar("Please Select Patient", "OK");
      this.ngOnInit();
    }
  }


  selectedBookingdata(obj: any) {

    document.getElementById("BillingResonModel").style.display = "none";
    this.PackageListArray = [];
    this.bookingtype = true;
    this.setIpdRegistrationFormbybooking(obj)
  }


  closeselectedBookingdata() {
    document.getElementById("BillingResonModel").style.display = "none";
    // this.setIpdRegistrationFormbybooking(obj)
  }









  opendocdialog(): void {
    // ;
    // call dialogue

    if (this.IpdRegistrationModel.PK_IPDId > 0) {
      const dialogRef = this.dialog.open(PatientDocumentComponent, {
        panelClass: "full-width-dialog",
        maxWidth: "80vw",
        // height: "90%",
        width: "60%",
        data: { PatinetId: this.IpdRegistrationModel.PK_IPDId, checkboth: 0 }
      });

      dialogRef.afterClosed().pipe(takeUntil(this.destroy$)).subscribe(result => {
        console.log("The dialog was closed");
        // this.animal = result;
      });

    }

    else {
      this.dashboardService.openSnackBar("Please create new admission or select existing record.", "OK");
    }

  }

  open_loader_Dialog(): void {
    const dialogRef = this.dialog.open(SiteloaderComponent, {
      width: "300px",
      panelClass: 'site-loader',
      data: {

      }
    });

    dialogRef.afterClosed().pipe(takeUntil(this.destroy$)).subscribe(result => {
      console.log("The dialog was closed");

    });
  }

  opensearchD(): void {
    // this.refreshPage();
    // this.open_loader_Dialog();
    // this.opdvisitService.get_top_200_patients().subscribe(
    //   data => this.success_top_200_patients(data),
    // );
    const dialogRef = this.dialog.open(SearchDialogComponent, {
      panelClass: "full-width-dialog",
      maxWidth: "100vw !important",
      height: "80%",
      width: "90%"
    });

    dialogRef.afterClosed().pipe(takeUntil(this.destroy$)).subscribe(result => {
      //  this.getpatientlastvisit(this.opdvisitService.checkpatient);
      this.PatientObj = this.opdvisitService.patientdetails;
      this.patientID = this.PatientObj.pkRegId;
      this.getImage(this.PatientObj.pkRegId);
      // console.log('patId',this.PatientObj);
      // this.ipdService.getIpdDetailbyId(this.PatientObj.pkRegId).subscribe(data=> this.getIpdSuccessbyId(data,this.PatientObj.pkRegId),
      // err=> this.getIpdFailedbyId(err))
      this.getpatiendId(this.PatientObj.pkRegId, 0)
      this.setIpdRegistrationForm();
      // this.opdvisitService.patientdetails.pkRegId =data.pkRegId;
    });
  }

  // success_top_200_patients(data) {
  //   this.dialog.closeAll();
  //   this.opdvisitService.patients = data;
  //   const dialogRef = this.dialog.open(SearchDialogComponent, {
  //     panelClass: "full-width-dialog",
  //     maxWidth: "100vw !important",
  //     height: "80%",
  //     width: "90%"
  //   });

  //   dialogRef.afterClosed().subscribe(result => {
  //   //  this.getpatientlastvisit(this.opdvisitService.checkpatient);
  //   this.PatientObj =  this.opdvisitService.patientdetails;
  //   this.patientID = this.PatientObj.pkRegId;
  //   this.getImage(this.PatientObj.pkRegId);
  //   // console.log('patId',this.PatientObj);
  //   // this.ipdService.getIpdDetailbyId(this.PatientObj.pkRegId).subscribe(data=> this.getIpdSuccessbyId(data,this.PatientObj.pkRegId),
  //   // err=> this.getIpdFailedbyId(err))
  //   this.setIpdRegistrationForm();
  //   // this.opdvisitService.patientdetails.pkRegId =data.pkRegId;
  //    });
  // }

  searchIpdPatient() {
    if (this.screenPermissionobj?.searchPermission === true) {

      // this.ngOnInit();
      const dialogRef = this.dialog.open(SearchIpdPatientComponent, {
        panelClass: 'full-width-dialog',
        // height: '100%',
        width: '100%',
        data: {}

      });

      dialogRef.afterClosed().pipe(takeUntil(this.destroy$)).subscribe(result => {

        //  this.PatientObj = this.ipdService.selectePatientData;
        this.getipdregDetail(this.ipdService.selectePatientData.pK_IPDId);

        // if (this.PatientObj != null) {
        //   this.bookingtype=this.PatientObj?.viaBooking?this.PatientObj?.viaBooking:false;
        //   this.patientID = this.PatientObj.fK_RegId;
        //   this.partyName = this.PatientObj?.partyName;
        //   this.setupdateIpdRegistrationForm(this.PatientObj);
        //   this.getpatiendId(this.patientID,1);
        // }
      });

    }

    else {
      this.dashboardService.openSnackBar("you don't have permission to access this resource", "OK");
    }
  }

  getpatiendId(id: number, type?: any) {
    if (id) {
      this.opdvisitService.getpatientdetailsforReciept(id).pipe(takeUntil(this.destroy$)).subscribe(data => this.patient_succsess(data, type), err => this.patient_failed(err));
    }
  }




  getTypeIdp() {
    this.ipdService.getIPDtype().pipe(takeUntil(this.destroy$)).subscribe(data => {
      this.IPDTypeListArray = data;
      //  console.log('ipd type',this.IPDTypeListArray );
    })
  }

  patient_succsess(data, type) {
    if (data.pkRegId > 0) {
      this.opdvisitService.patientdetails = {};
      this.opdvisitService.patientdetails = data;
      if (type == 1) {
        this.PatientObj = data;
        this.patientID = this.PatientObj.pkRegId;

      } else {
        this.PatientObj = data;
        this.patientID = this.PatientObj.pkRegId;
        if (this.PatientObj.fkPartyId == null || this.PatientObj.fkPartyId == 0) {
          this.partyName = '';
        } else {
          let getpartyname = this.billingservice.partytpa.filter(item => item.pkPartyId == this.PatientObj.fkPartyId);
          this.partyName = getpartyname[0].partyName;
        }
        if (data.dob != null) {
          this.opdvisitService.patientdetails.dob = this.datePipe.transform(data.dob, "yyyy-MM-dd");
          this.opdvisitService.getages(data.dob);
        } else {
          var tdate = this.authService.localDate;
          this.opdvisitService.patientdetails.ageYear = this.opdvisitService.patientdetails.ageYear != null ? this.opdvisitService.patientdetails.ageYear : 0;
          this.opdvisitService.patientdetails.ageMonth = this.opdvisitService.patientdetails.ageMonth != null ? this.opdvisitService.patientdetails.ageMonth : 0;
          this.opdvisitService.patientdetails.ageDays = this.opdvisitService.patientdetails.ageDays != null ? this.opdvisitService.patientdetails.ageDays : 0;
          tdate.setDate(tdate.getUTCDate() - this.opdvisitService.patientdetails.ageDays);
          tdate.setMonth(tdate.getMonth() - this.opdvisitService.patientdetails.ageMonth);
          tdate.setFullYear(tdate.getFullYear() - this.opdvisitService.patientdetails.ageYear);
          this.opdvisitService.patientdetails.dob = this.datePipe.transform(tdate, "yyyy-MM-dd");
          this.opdvisitService.getDataDiffs(new Date(this.opdvisitService.patientdetails.dob), new Date(this.datePipe.transform(this.authService.localDate, "yyyy-MM-dd")));
        }

        this.PatientObj.bod = this.opdvisitService.patientdetails.dob;
        this.PatientObj.ageYear = this.opdvisitService.patientdetails.ageYear;
        this.PatientObj.ageMonth = this.opdvisitService.patientdetails.ageMonth;
        this.PatientObj.ageDays = this.opdvisitService.patientdetails.ageDays;
        this.getImage(data.pkRegId);
        this.setDefailtsomeFields();
        this.opdvisitService.patientdetails.pkRegId = data.pkRegId;
        this.getBillSummery(this.opdvisitService.patientdetails.pkRegId);
        if (this.PatientObj.isExpired === true) {
          this.dashboardService.openSnackBar("This Patient is Expired ", "OK");
        }
        this.setIpdRegistrationForm();
      }

    }
    else {
      this.dashboardService.openSnackBar("This Patient is Not Registered ", "OK");
    }
  }

  get_patient_docurl() {
    this.dashboardService.getsummary_url().pipe(takeUntil(this.destroy$))
      .subscribe(
        data => this.successdocsurl(data), err => this.faileddocsurl(err)
      )
  }
  successdocsurl(data) {
    this.documentrul = data;
    var urldoc = this.documentrul.filter(item => item?.propertyName == "MainImagePathWebNetram")
    this.mainUrl = urldoc[0]?.propertyValue;
    var barcodecheck = this.documentrul.filter(item => item?.propertyName == "Patientsticker_barcode")
    if (barcodecheck[0]?.propertyValue == "Y") {
      this.patientbarcodecheck = true;
    } else {
      this.patientbarcodecheck = false;
    }
    var strickerprint = this.documentrul.filter(item => item?.propertyName == "PatientStickerRegistration")
    if (strickerprint[0]?.propertyValue == "Y") {
      this.patientregistrikerprint = true;
    } else {
      this.patientregistrikerprint = false;
    }

  }
  faileddocsurl(err) {
   if (err.status == 403) {
        this.dashboardService.openSnackBar("You Don't have Permission", "OK");
      } else if (err.error.statusCode == 422) {
        this.dashboardService.openSnackBar(err.error.message, "OK");
      } else {
        this.dashboardService.openSnackBar("API Failed", "OK");
      }
  }

  getImage(patRegId) {
    this.opdvisitService.get_old_photo();
    
  }
  

  patient_failed(err) {
    this.dashboardService.openSnackBar("Patient Not found", "OK");
    this.opdvisitService.patientdetails.pkRegId = null;
    this.IpdRegistrationModel.FK_RegId = null;

  }
  getipddetail: any = [];
  getIpdSuccessbyId(data) {

    this.getipddetail = [];
    this.getipddetail = data;
    if (data.length > 0) {
      for (let i = 0; i < data.length; i++) {   //isDischarge
        if (this.datePipe.transform(data[i].ipdAdmDate, "yyyy-MM-dd") === this.dashboardService.selecteddate && this.checkIpdPatient === 'Y') {
          this.dashboardService.openSnackBar("Admission already done today for this Registration Id", "OK");
          if (this.billdetailArray.length > 0) {
            document.getElementById("patientBillingDetailsModel").style.display = "block";
          }

          this.isdisable = true
        }
        else if (data[i].isDischarge === false) {
          document.getElementById("IpdResonModel").style.display = "block";
          // this.dashboardService.openSnackBar("Patient is already Admited , Do you want to make  Admission ones Again", "OK");

        }
      }
    } else {
      if (this.billdetailArray.length > 0) {
        this.patientBillingDetails();
      }
    }

  }

  OpentodayOneMoreAddmission() {
    document.getElementById("IpdResonModel").style.display = "block";
    this.isdisable = false
  }

  ClosetodayOneMoreAddmission() {
    document.getElementById("IpdResonModel").style.display = "none";
    this.isdisable = true
  }

  totalbalanceAMount: number = 0;
  billdetailArray: any = [];
  getBillSummery(id) {

    this.billdetailArray = [];
    this.totalbalanceAMount = 0;
    this.ipdService.getbillSummery(id).pipe(takeUntil(this.destroy$)).subscribe((x: any) => {
      if (x.length > 0) {
        this.billdetailArray = x.filter(item => item.balance != 0);

        this.totalbalanceAMount = 0;
        this.billdetailArray.forEach(item => {
          this.totalbalanceAMount = this.totalbalanceAMount + item.balance;
        });

        this.ipdService.getIpdDetailbyId(id).pipe(takeUntil(this.destroy$)).subscribe(data => this.getIpdSuccessbyId(data),
          err => this.getIpdFailedbyId(err))

      } else {
        this.totalbalanceAMount = 0;
        this.ipdService.getIpdDetailbyId(id).pipe(takeUntil(this.destroy$)).subscribe(data => this.getIpdSuccessbyId(data),
          err => this.getIpdFailedbyId(err))
      }
    }, err => {
      if (err.status == 403) {
        this.dashboardService.openSnackBar("You Don't have Permission", "OK");
      } else if (err.error.statusCode == 422) {
        this.dashboardService.openSnackBar(err.error.message, "OK");
      } else {
        this.dashboardService.openSnackBar("API Failed", "OK");
      }
    })
  }
  patientBillingDetails() {

    document.getElementById("patientBillingDetailsModel").style.display = "block";
    this.isdisable = false
  }

  closePatientBillingDetails() {

    document.getElementById("patientBillingDetailsModel").style.display = "none";
    document.getElementById("IpdResonModel").style.display = "none";
    this.isdisable = false;


  }


  ipdTypeModel() {
    document.getElementById("ipdTypeModel").style.display = "block";
    this.isdisable = false
  }

  closeipdTypeModel() {
    document.getElementById("ipdTypeModel").style.display = "none";
    this.isdisable = true
  }





  getIpdFailedbyId(err) {
   if (err.status == 403) {
        this.dashboardService.openSnackBar("You Don't have Permission", "OK");
      } else if (err.error.statusCode == 422) {
        this.dashboardService.openSnackBar(err.error.message, "OK");
      } else {
        this.dashboardService.openSnackBar("API Failed", "OK");
      }
    // this.opdvisitService.getpatientdetailsforReciept(id).subscribe(data=>this.patient_succsess(data),err=> this.patient_failed(err) );
  }

  removeRow(x, element, check: string) {

    console.log(x, element, check);
    if (check === 'upgrade') {
      this.UpgradePackageListArray.splice(x, 1);
      this.paymentDetail(this.UpgradePackageListArray, 'upgrade')
    }
    if (check === 'normal') {
      this.PackageListArray.splice(x, 1);
      this.paymentDetail(this.PackageListArray, 'normal');
    }
    if (element.pK_TranId > 0) {
      this.deletePackageArray.push(element);
      // this.deletePackageArray.map(item=> item.isDelete = true);
    }
    // if (this.IpdRegistrationModel.PK_IPDId > 0) {
    //   this.ipdService.deletePackage(element.pK_TranId).subscribe(data => {

    //   })
    // }


    //  var newelement = element.isDelete =1;
    //  console.log('newelement',newelement);
    // this.RemoveServiceArray.push(element);
    // console.log('remove',this.RemoveServiceArray);

    // // this.BillDetailArray.splice(x)
    //   this.BillDetailArray.splice(x, 1 );
    //  this.dataSource.data= this.BillDetailArray;
    //  this.paymentDetail(this.BillDetailArray);
  }


  public onMlcChanged(event) {
    // console.log(event.checked);
    this.IpdRegistrationModel.MLC = event.checked;
    console.log(this.IpdRegistrationModel.MLC);
  }



  public onOneEyedChanged(event) {
    this.IpdRegistrationModel.MLC
    this.IpdRegistrationModel.IsOneEyed = event.checked;
  }

  getscreenPermission() {
    let useridId = this.authService.Loggeduser.userid;
    this.billingservice.getbillingScreenPermission(useridId).pipe(takeUntil(this.destroy$)).subscribe(data => {
      // console.log('screenPermissionobj nnn',data)
      for (let i = 0; i < data.length; i++) {
        const element = data[i];
        if (element.screenName === "IPDREGISTRATION") {
          this.screenPermissionobj = element;

          console.log('screenPermissionobj', this.screenPermissionobj);
        }

      }

    })
  }

  //check focus
  @ViewChild('refredname', { static: false }) private Refredname: ElementRef;
  @ViewChild('consultRef', { static: false }) private ConsultRef: ElementRef;
  @ViewChild('coSurgeon', { static: false }) private COSurgeonRef: ElementRef;
  @ViewChild('wardbedref', { static: false }) private WardBedRef: ElementRef;
  @ViewChild('catrefname', { static: false }) private CatRefname: ElementRef;
  @ViewChild('partyrefname', { static: false }) private PartyRefname: ElementRef;


  //check condition 
  UHIDVliadtion: boolean = false;
  docValidation: boolean = false;
  consultantValidation: boolean = false;
  refValidation: boolean = false;
  cosurgronValidation: boolean = false;
  wardValidation: boolean = false;
  catValidation: boolean = false;
  partyValidation: boolean = false;
  SaveIPDInfo() {

    if (this.screenPermissionobj?.addPermission === true) {

      if (this.PatientObj?.isExpired === true) {
        this.dashboardService.openSnackBar("Patient Is Expired", "OK");
      }
      else if (this.IpdRegistrationModel.FK_RegId === null ||
        this.IpdRegistrationModel.FK_RegId === undefined) {
        this.dashboardService.openSnackBar("Please Select Patient Name", "OK");
      }
      else if (this.IpdRegistrationModel.FK_ReferedById === null ||
        this.IpdRegistrationModel.FK_ReferedById === undefined || this.ShowReferdByName == "") {
        this.refValidation = true;
        setTimeout(() => {
          this.Refredname.nativeElement.focus();
        }, 100);
        this.dashboardService.openSnackBar("Please Select Referred By", "OK");
      }
      else if (this.IpdRegistrationModel.FK_ConsultantId === null ||
        this.IpdRegistrationModel.FK_ConsultantId === undefined || this.ShowDoctorName == "") {
        this.consultantValidation = true;
        setTimeout(() => {
          this.ConsultRef.nativeElement.focus();
        }, 100);
        this.dashboardService.openSnackBar("Please Select Consultant", "OK");
      }
      else if (this.IpdRegistrationModel.FK_ConsultantID2 === null ||
        this.IpdRegistrationModel.FK_ConsultantID2 === undefined || this.ShowDoctorName2 == "") {
        this.cosurgronValidation = true;
        setTimeout(() => {
          this.COSurgeonRef.nativeElement.focus();
        }, 100);
        this.dashboardService.openSnackBar("Please Select Co-Surgeon", "OK");
      }
      else if (this.IpdRegistrationModel.FK_WardID === null ||
        this.IpdRegistrationModel.FK_WardID === undefined) {
        this.wardValidation = true;
        setTimeout(() => {
          this.WardBedRef.nativeElement.focus();
        }, 100);
        this.dashboardService.openSnackBar("Please Select Ward Name", "OK");
      }
      else if (this.IpdRegistrationModel.FK_CategoryId === null ||
        this.IpdRegistrationModel.FK_CategoryId === undefined || this.ShowCateName == "") {
        this.catValidation = true;
        setTimeout(() => {
          this.CatRefname.nativeElement.focus();
        }, 100);
        this.dashboardService.openSnackBar("Please Select Category Name", "OK");
      }
      else if (this.IpdRegistrationModel.FK_PartyId === null ||
        this.IpdRegistrationModel.FK_PartyId === undefined || this.ShowPartyName == "") {
        this.partyValidation = true;
        setTimeout(() => {
          this.PartyRefname.nativeElement.focus();
        }, 100);
        this.dashboardService.openSnackBar("Please Select Party Name", "OK");
      }
      else {
        this.dashboardService.open_loader_Dialog();
        var PackageArray1 = [];
        var PackageArray2 = [];
        var RegDetailDto = [];
        RegDetailDto.push({
          "IsEdit": false,
          "PK_TranID": 0,
          "FK_IPDID": 0,
          "FK_BedID": this.IpdRegistrationModel.FK_WardID,
          "FK_CreatedByID": this.authService.Loggeduser.userid,
          "FK_BillingBedID": this.IpdRegistrationModel.FK_WardID,
          "IsUnderPackage": false,
          "NewBedId": this.IpdRegistrationModel.FK_WardID
        })
        if (this.PackageListArray?.length > 0)
          this.PackageListArray.forEach(element => {
            PackageArray1.push({ "PK_TranId": 0, "FK_IPDId": element.fK_IPDId ? element.fK_IPDId : 0, "DiscountPer": element.discountPer ? element.discountPer : null, "FK_ConsID": this.IpdRegistrationModel.FK_ConsId ? this.IpdRegistrationModel.FK_ConsId : null, FK_PackageId: element.fK_PackageId ? element.fK_PackageId : element.pK_PackageId, "Amount": element.amount })
          });

        // if (this.UpgradePackageListArray?.length > 0)
        // this.UpgradePackageListArray.forEach(element => {
        //   PackageArray2.push({ "PK_TranId": element.pK_TranId, "FK_IPDId": element.fK_IPDId, FK_PackageId: element.fK_PackageId? element.fK_PackageId :element.pK_PackageId,"DiscountPer":element.discountPer?element.discountPer:null, "FK_ConsID": element.FK_ConsID?element.FK_ConsID:null, "Amount": element.amount })
        // });
        this.IpdRegistrationModel.UpgradeAmount = this.totalupgradedAmount;
        this.IpdRegistrationModel.PK_IPDId = 0;
        this.IpdRegistrationModel.Fk_SpecialityIdModule = this.authService.Loggeduser.specialityId;
        var finalobj = {
          IpdRegMaster: this.IpdRegistrationModel,
          IpdPackageDetail: PackageArray1,
          IpdPackageUpgradeDetail: PackageArray2,
          RegDetailDto: RegDetailDto
        }


        this.ipdService.insertIpdRegistration(finalobj).pipe(takeUntil(this.destroy$)).subscribe(data => this.insert_succsess(data), err => this.insert_failed(err))
      }
    }
    else {
      this.dialog.closeAll();
      this.dashboardService.openSnackBar("you don't have permission to access this resource", "OK");
    }
  }


  insert_succsess(data) {
    this.dialog.closeAll();
    this.dashboardService.openSnackBar("Record Saved Successfully", "OK");
    this.ToDate = this.fromDate;
    this.ToTime = this.fromTime;
    // console.log('resp',data)
    if (data) {
      this.IpdRegistrationModel.PK_IPDId = data.id;
      // this.PackageListArray =[];
      // this.UpgradePackageListArray =[];
      this.setpackageforUpdate(this.IpdRegistrationModel.PK_IPDId);
      this.getipdregDetail(this.IpdRegistrationModel.PK_IPDId);
      this.getBedDetail(this.IpdRegistrationModel.PK_IPDId);
      // this.setupgradepackageforUpdate(this.IpdRegistrationModel.PK_IPDId);
    }

  }

  insert_failed(err) {
    this.dialog.closeAll();
   if (err.status == 403) {
        this.dashboardService.openSnackBar("You Don't have Permission", "OK");
      } else if (err.error.statusCode == 422) {
        this.dashboardService.openSnackBar(err.error.message, "OK");
      } else {
        this.dashboardService.openSnackBar("API Failed", "OK");
      }
  }

  getipdregDetail(ipd) {
    this.ipdService.GetIpdRegByIPDId(ipd).pipe(takeUntil(this.destroy$)).subscribe((x: any) => {
      if (x.length > 0) {
        this.PatientObj = x[0];
        this.bookingtype = this.PatientObj?.viaBooking ? this.PatientObj?.viaBooking : false;
        this.patientID = this.PatientObj.fK_RegId;
        this.partyName = this.PatientObj?.partyName;
        this.setupdateIpdRegistrationForm(this.PatientObj);
        // this.getpatiendId(this.patientID, 1);
      }

    }, err => {
     if (err.status == 403) {
        this.dashboardService.openSnackBar("You Don't have Permission", "OK");
      } else if (err.error.statusCode == 422) {
        this.dashboardService.openSnackBar(err.error.message, "OK");
      } else {
        this.dashboardService.openSnackBar("API Failed", "OK");
      }
    })
  }
  setpackageforUpdate(id) {
    this.ipdService.GetpackagebyIpdId(id).pipe(takeUntil(this.destroy$)).subscribe(data => {
      this.PackageListArray = [];
      this.PackageListArray = data;
      this.PackageListArray = this.PackageListArray?.reduce((unique, o) => {
        if (!unique.some(obj => obj.packageName === o.packageName && obj.packageAmount === o.packageAmount)) {
          unique.push(o);
        }
        return unique;
      }, []);
      this.paymentDetail(this.PackageListArray, 'normal');
    }, err => {
     if (err.status == 403) {
        this.dashboardService.openSnackBar("You Don't have Permission", "OK");
      } else if (err.error.statusCode == 422) {
        this.dashboardService.openSnackBar(err.error.message, "OK");
      } else {
        this.dashboardService.openSnackBar("API Failed", "OK");
      }
    })


  }

  setupgradepackageforUpdate(id) {
    this.ipdService.GetUpgradedpackagebyIpdId(id).pipe(takeUntil(this.destroy$)).subscribe(data => {
      this.UpgradePackageListArray = data;
      this.paymentDetail(this.UpgradePackageListArray, 'upgrade');
    }, err => {
     if (err.status == 403) {
        this.dashboardService.openSnackBar("You Don't have Permission", "OK");
      } else if (err.error.statusCode == 422) {
        this.dashboardService.openSnackBar(err.error.message, "OK");
      } else {
        this.dashboardService.openSnackBar("API Failed", "OK");
      }
    })

  }

  refReasonPOpup(type) {
    this.IpdRegistrationModel.counseloreRemarks = '';
    const dialogRef = this.dialog.open(DynamicHelpListComponent, {
      panelClass: 'full-width-dialog',
      maxWidth: '33vw',
      disableClose: true,
      width: '33%',

      data: {
        parametertype: type
      }

    });

    dialogRef.afterClosed().pipe(takeUntil(this.destroy$)).subscribe(result => {
      if (result != 0) {
        this.IpdRegistrationModel.counseloreRemarks = result;

      }
    });
  }
  refIpdTypePOpup(type) {
    const dialogRef = this.dialog.open(DynamicHelpListComponent, {
      panelClass: 'full-width-dialog',
      maxWidth: '33vw',
      disableClose: true,
      width: '33%',

      data: {
        parametertype: type
      }

    });

    dialogRef.afterClosed().pipe(takeUntil(this.destroy$)).subscribe(result => {
      if (result != 0) {
        if (type == 'IPDCategory') {
          this.IpdRegistrationModel.IPDType = result;

        } else {
          this.IpdRegistrationModel.Reason = result;
        }
      }
    }, err => {
     if (err.status == 403) {
        this.dashboardService.openSnackBar("You Don't have Permission", "OK");
      } else if (err.error.statusCode == 422) {
        this.dashboardService.openSnackBar(err.error.message, "OK");
      } else {
        this.dashboardService.openSnackBar("API Failed", "OK");
      }
    });
  }
  bedinformationArray: any = [];
  getBedDetail(ipdid) {

    this.ipdService.GetIpdRegDetailbed(ipdid).pipe(takeUntil(this.destroy$)).subscribe((x: any) => {
      this.bedinformationArray = [];
      this.bedinformation = false;
      if (x.length > 0) {
        this.bedinformationArray = x;
      }
    }, err => {
     if (err.status == 403) {
        this.dashboardService.openSnackBar("You Don't have Permission", "OK");
      } else if (err.error.statusCode == 422) {
        this.dashboardService.openSnackBar(err.error.message, "OK");
      } else {
        this.dashboardService.openSnackBar("API Failed", "OK");
      }
    })
  }
  deletePackageArray = [];
  UpdateIPDInfo() {

    if (this.screenPermissionobj?.modifyPermission === true) {
      if (this.PatientObj.isExpired === true) {
        this.dashboardService.openSnackBar("Patient Is Expired", "OK");
      }
      else if (this.IpdRegistrationModel.FK_RegId === null ||
        this.IpdRegistrationModel.FK_RegId === undefined) {
        this.dashboardService.openSnackBar("Please Select Patient Name", "OK");
      }
      else if (this.IpdRegistrationModel.FK_ReferedById === null ||
        this.IpdRegistrationModel.FK_ReferedById === undefined || this.ShowReferdByName == "") {
        this.dashboardService.openSnackBar("Please Select Referred By", "OK");
      }
      else if (this.IpdRegistrationModel.FK_ConsultantId === null ||
        this.IpdRegistrationModel.FK_ConsultantId === undefined || this.ShowDoctorName == "") {
        this.dashboardService.openSnackBar("Please Select Consultant", "OK");
      }
      else if (this.IpdRegistrationModel.FK_WardID === null ||
        this.IpdRegistrationModel.FK_WardID === undefined) {
        this.dashboardService.openSnackBar("Please Select Ward Name", "OK");
      }
      else if (this.IpdRegistrationModel.FK_ConsultantID2 === null ||
        this.IpdRegistrationModel.FK_ConsultantID2 === undefined || this.ShowDoctorName2 == "") {
        this.dashboardService.openSnackBar("Please Select Consultant-2", "OK");
      }
      else if (this.IpdRegistrationModel.FK_CategoryId === null ||
        this.IpdRegistrationModel.FK_CategoryId === undefined || this.ShowCateName == "") {
        this.dashboardService.openSnackBar("Please Select Category Name", "OK");
      }
      else if (this.IpdRegistrationModel.FK_PartyId === null ||
        this.IpdRegistrationModel.FK_PartyId === undefined || this.ShowPartyName == "") {
        this.dashboardService.openSnackBar("Please Select Party Name", "OK");
      }
      else {

        var PackageArray1 = [];
        var PackageArray2 = [];
        var RegDetailDto = [];
        RegDetailDto.push({
          "IsEdit": true,
          "PK_TranID": this.bedinformationArray[0]?.pK_TranID,
          "FK_IPDID": this.bedinformationArray[0]?.fK_IPDID,
          "FK_BedID": this.bedinformationArray[0]?.fK_BedID,
          "FK_CreatedByID": this.authService.Loggeduser.userid,
          "FK_BillingBedID": this.IpdRegistrationModel.FK_WardID,
          "IsUnderPackage": false,
          "NewBedID": this.IpdRegistrationModel.FK_WardID
        })


        if (this.PackageListArray?.length > 0) {

          this.PackageListArray?.forEach(element => {
            PackageArray1.push({ "PK_TranId": element.pK_TranId ? element.pK_TranId : 0, "FK_IPDId": element.fK_IPDId ? element.fK_IPDId : 0, "DiscountPer": element.discountPer ? element.discountPer : null, "FK_ConsID": this.IpdRegistrationModel.FK_ConsId ? this.IpdRegistrationModel.FK_ConsId : null, FK_PackageId: element.fK_PackageId, "Amount": element.amount })
          });
        }
        // if (this.UpgradePackageListArray?.length > 0)
        //   this.UpgradePackageListArray?.forEach(element => {
        //     PackageArray2.push({ "PK_TranId": 0, "FK_IPDId": 0, FK_PackageId: element.pK_PackageId, "FK_ConsID": element.FK_ConsID, "Amount": element.amount })
        //   });
        if (this.deletePackageArray.length > 0) {
          this.deletePackageArray.forEach(item => {
            this.ipdService.deletePackage(item.pK_TranId).pipe(takeUntil(this.destroy$)).subscribe(data => {
              //  console.log(data);
            })
          })
        }
        this.IpdRegistrationModel.UpgradeAmount = this.totalupgradedAmount
        this.IpdRegistrationModel.Fk_SpecialityIdModule = this.authService.Loggeduser.specialityId;

        var finalobj = {
          IpdRegMaster: this.IpdRegistrationModel,
          IpdPackageDetail: PackageArray1,
          IpdPackageUpgradeDetail: PackageArray2,
          RegDetailDto: RegDetailDto
        }

        this.dashboardService.open_loader_Dialog();
        this.ipdService.insertIpdRegistration(finalobj).pipe(takeUntil(this.destroy$)).subscribe(data => this.update_succsess(data), err => this.update_failed(err));
      }
    }
    else {
      this.dialog.closeAll();
      this.dashboardService.openSnackBar("you don't have permission to access this resource", "OK");
    }
  }




  update_succsess(data) {
    this.dialog.closeAll();
    this.oldPackageData = [];
    this.isdisable = false;
    if (data) {
      this.IpdRegistrationModel.PK_IPDId = data.id;
      this.PackageListArray = [];
      this.UpgradePackageListArray = [];
      this.getipdregDetail(this.IpdRegistrationModel.PK_IPDId)
      this.setpackageforUpdate(this.IpdRegistrationModel.PK_IPDId);
      this.getBedDetail(this.IpdRegistrationModel.PK_IPDId);
    }
    this.deletePackageArray = [];
    this.dashboardService.openSnackBar("Record Updated Successfully", "OK");
    this.ToDate = this.fromDate;
    this.ToTime = this.fromTime;
  }

  update_failed(err) {
    this.dialog.closeAll();
   if (err.status == 403) {
        this.dashboardService.openSnackBar("You Don't have Permission", "OK");
      } else if (err.error.statusCode == 422) {
        this.dashboardService.openSnackBar(err.error.message, "OK");
      } else {
        this.dashboardService.openSnackBar("API Failed", "OK");
      }
  }

  setfreshIpdRegistrationForm() {

    this.IpdRegistrationModel.PK_IPDId = 0;
    this.IpdRegistrationModel.FK_BranchId = this.authService.Loggeduser.branchid;
    this.IpdRegistrationModel.FK_RegId = null;
    this.IpdRegistrationModel.ViaBooking = false;
    this.IpdRegistrationModel.FK_ConsId = null;
    this.IpdRegistrationModel.IPDAdmDate = this.dashboardService.selecteddate;
    this.IpdRegistrationModel.IPDAdmTime = new Date().toTimeString().split(" ")[0];
    this.IpdRegistrationModel.AgeYear = null;
    this.IpdRegistrationModel.AgeMonth = null;
    this.IpdRegistrationModel.AgeDays = null;
    this.IpdRegistrationModel.Gaurdian = '';
    // this.IpdRegistrationModel.FK_ReferedById = 1;
    this.IpdRegistrationModel.MLC = false;
    this.IpdRegistrationModel.IsDischarge = false;
    this.IpdRegistrationModel.DOD = null;
    this.IpdRegistrationModel.TOD = null;
    // this.IpdRegistrationModel.FK_WardID = 1;
    //this.IpdRegistrationModel.FK_PartyId = 1;
    this.IpdRegistrationModel.RateType = 1;
    this.IpdRegistrationModel.Remarks = '';
    this.IpdRegistrationModel.ipdType = '';
    //this.IpdRegistrationModel.FK_CategoryId = 1;
    // this.IpdRegistrationModel.fK_RoomCategoryId = 1;
    // this.IpdRegistrationModel.PK_SynchId=0;
    this.IpdRegistrationModel.OLDIPDID = '';
    this.IpdRegistrationModel.IsOneEyed = false;
    this.IpdRegistrationModel.FK_LocationId = 1;
    this.IpdRegistrationModel.IsDischargeApproveByDr = false;
    this.IpdRegistrationModel.IsDischargeApproveByAdmin = false;
    this.IpdRegistrationModel.ManualIPNO = null;
    this.IpdRegistrationModel.FK_CreatedById = this.authService.Loggeduser.userid;
    this.IpdRegistrationModel.FK_ModifiedById = this.authService.Loggeduser.userid;
    this.IpdRegistrationModel.IPDNO = 0;
    this.IpdRegistrationModel.surgerydate = this.datePipe.transform(this.authService.localDate, "yyyy-MM-dd");
    this.IpdRegistrationModel.Reason = '';
    this.IpdRegistrationModel.FK_UpgradeServiceID = null;
    this.IpdRegistrationModel.UpgradeAmount = null;
    this.IpdRegistrationModel.IsOTConsentTaken = null;
    this.IpdRegistrationModel.ClinicalApprovalComments = '';
    this.IpdRegistrationModel.FinancialApprovalComments = '';
    this.IpdRegistrationModel.counseloreRemarks = '';
    this.IpdRegistrationModel.Reinreason = '';
    this.IpdRegistrationModel.FingurePrintUsed = 0;
    this.IpdRegistrationModel.FingurePrintTaken = 0;
    this.IpdRegistrationModel.IsPosponed = 0;
    this.IpdRegistrationModel.LastUpdatedDateTime = new Date().toTimeString().split(" ")[0];
    this.IpdRegistrationModel.FK_LastUpdatedById = this.authService.Loggeduser.userid;
    this.IpdRegistrationModel.OperatingTime = new Date().toTimeString().split(" ")[0];
    this.IpdRegistrationModel.ChkOperatingtime = 1;
    this.IpdRegistrationModel.BlockRoomTime = new Date().toTimeString().split(" ")[0];
    this.IpdRegistrationModel.ChkBlockRoom = 1;
    this.IpdRegistrationModel.PostponTimePCD = new Date().toTimeString().split(" ")[0];
    this.IpdRegistrationModel.ChkPostponPCD = 0;
    this.IpdRegistrationModel.BillingTime = new Date().toTimeString().split(" ")[0];
    this.IpdRegistrationModel.ChkBilling = 1;
    this.IpdRegistrationModel.DilationTime = new Date().toTimeString().split(" ")[0];
    this.IpdRegistrationModel.ChkDilation = 0;
    this.IpdRegistrationModel.OTInTime = new Date().toTimeString().split(" ")[0];
    this.IpdRegistrationModel.ChkOTIn = 1;
    this.IpdRegistrationModel.OTOutTime = new Date().toTimeString().split(" ")[0];
    this.IpdRegistrationModel.ChkOTOut = 1;
    this.IpdRegistrationModel.PostponTime = new Date().toTimeString().split(" ")[0];
    this.IpdRegistrationModel.ChkPostpon = 1;
    this.IpdRegistrationModel.InsuranceClearedTime = new Date().toTimeString().split(" ")[0];
    this.IpdRegistrationModel.PreOPTime = new Date().toTimeString().split(" ")[0];
    this.IpdRegistrationModel.ChkInsuranceCleared = 0;
    this.IpdRegistrationModel.ChkPreOP = 1;
    this.IpdRegistrationModel.Billing = null;
    this.IpdRegistrationModel.NurseRemarks = 47;
    this.IpdRegistrationModel.Instruction = 46;
    this.IpdRegistrationModel.FK_CalledByID = 1;
    this.IpdRegistrationModel.Iscalled = 1;
    this.IpdRegistrationModel.tokenNo = 43;
    console.log('fesh', this.IpdRegistrationModel);

  }


  setIpdRegistrationForm() {

    this.PatinetName = this.PatientObj?.firstName + ' ' + this.PatientObj?.lastName;
    this.IpdRegistrationModel.PK_IPDId = 0;
    this.IpdRegistrationModel.FK_BranchId = this.authService.Loggeduser.branchid;
    this.IpdRegistrationModel.FK_RegId = this.PatientObj?.pkRegId;
    this.IpdRegistrationModel.ViaBooking = false;
    this.IpdRegistrationModel.FK_ConsId = null;
    this.IpdRegistrationModel.IPDAdmDate = this.dashboardService.selecteddate;
    this.IpdRegistrationModel.IPDAdmTime = new Date().toTimeString().split(" ")[0];
    this.IpdRegistrationModel.AgeYear = this.PatientObj?.ageYear;
    this.IpdRegistrationModel.AgeMonth = this.PatientObj?.ageMonth;
    this.IpdRegistrationModel.AgeDays = this.PatientObj?.ageDays;
    this.IpdRegistrationModel.Gaurdian = ' ';
    if (this.PatientObj?.fkReferredbyId != null && this.PatientObj?.fkReferredbyId != "") {
      this.IpdRegistrationModel.FK_ReferedById = this.PatientObj?.fkReferredbyId;
      let referedby = this.opdvisitService.personmaster.filter(item => item.pkPersonId == this.IpdRegistrationModel.FK_ReferedById);
      this.ShowReferdByName = referedby[0]?.personName;
    } else {
      // this.IpdRegistrationModel.FK_ReferedById = 1;
    }

    this.IpdRegistrationModel.MLC = false;
    this.IpdRegistrationModel.IsDischarge = false;
    this.IpdRegistrationModel.DOD = null
    this.IpdRegistrationModel.TOD = null
    this.IpdRegistrationModel.FK_WardID = null;
    if (this.PatientObj?.fkPartyId != null && this.PatientObj?.fkPartyId != "") {
      this.IpdRegistrationModel.FK_PartyId = this.PatientObj?.fkPartyId;
    } else {
      // this.IpdRegistrationModel.FK_PartyId = 1;
    }

    this.IpdRegistrationModel.RateType = 1;
    this.IpdRegistrationModel.Remarks = '';
    this.IpdRegistrationModel.counseloreRemarks = '';
    // this.IpdRegistrationModel.PK_SynchId = :0;
    this.IpdRegistrationModel.OLDIPDID = '';
    this.IpdRegistrationModel.IsOneEyed = false;
    this.IpdRegistrationModel.FK_LocationId = this.PatientObj?.fkSdLocationId;
    this.IpdRegistrationModel.IPDType = '';
    this.IpdRegistrationModel.IsDischargeApproveByDr = false;
    this.IpdRegistrationModel.IsDischargeApproveByAdmin = false;
    this.IpdRegistrationModel.ManualIPNO = null;
    this.IpdRegistrationModel.FK_CreatedById = this.authService.Loggeduser.userid;
    this.IpdRegistrationModel.FK_ModifiedById = null;
    this.IpdRegistrationModel.FK_CategoryId = this.dashboardService.categories[0]?.pkCategoryId;
    this.ShowCateName = this.dashboardService.categories[0]?.categoryName;
    this.IpdRegistrationModel.fK_RoomCategoryId = this.categoryRoomArray[0]?.pK_RoomCategoryId;
    this.roomcategoryName = '';
    this.IpdRegistrationModel.IPDNO = 0;
    this.IpdRegistrationModel.surgerydate = this.datePipe.transform(this.authService.localDate, "yyyy-MM-dd");
    this.IpdRegistrationModel.Reason = '';
    this.IpdRegistrationModel.FK_UpgradeServiceID = null;
    this.IpdRegistrationModel.UpgradeAmount = null;
    this.IpdRegistrationModel.IsOTConsentTaken = null;
    this.IpdRegistrationModel.ClinicalApprovalComments = '';
    this.IpdRegistrationModel.FinancialApprovalComments = '';
    this.IpdRegistrationModel.Reinreason = '';
    this.IpdRegistrationModel.FingurePrintUsed = 0;
    this.IpdRegistrationModel.FingurePrintTaken = 0;
    this.IpdRegistrationModel.IsPosponed = 0;
    this.IpdRegistrationModel.LastUpdatedDateTime = new Date().toTimeString().split(" ")[0];
    this.IpdRegistrationModel.FK_LastUpdatedById = this.authService.Loggeduser.userid;
    this.IpdRegistrationModel.OperatingTime = new Date().toTimeString().split(" ")[0];
    this.IpdRegistrationModel.ChkOperatingtime = 1;
    this.IpdRegistrationModel.BlockRoomTime = new Date().toTimeString().split(" ")[0];
    this.IpdRegistrationModel.ChkBlockRoom = 1;
    this.IpdRegistrationModel.PostponTimePCD = new Date().toTimeString().split(" ")[0];
    this.IpdRegistrationModel.ChkPostponPCD = 0;
    this.IpdRegistrationModel.BillingTime = new Date().toTimeString().split(" ")[0];
    this.IpdRegistrationModel.ChkBilling = 1;
    this.IpdRegistrationModel.DilationTime = new Date().toTimeString().split(" ")[0];
    this.IpdRegistrationModel.ChkDilation = 0;
    this.IpdRegistrationModel.OTInTime = new Date().toTimeString().split(" ")[0];
    this.IpdRegistrationModel.ChkOTIn = 1;
    this.IpdRegistrationModel.OTOutTime = new Date().toTimeString().split(" ")[0];
    this.IpdRegistrationModel.ChkOTOut = 1;
    this.IpdRegistrationModel.PostponTime = new Date().toTimeString().split(" ")[0];
    this.IpdRegistrationModel.ChkPostpon = 1;
    this.IpdRegistrationModel.InsuranceClearedTime = new Date().toTimeString().split(" ")[0];
    this.IpdRegistrationModel.PreOPTime = new Date().toTimeString().split(" ")[0];
    this.IpdRegistrationModel.ChkInsuranceCleared = 0;
    this.IpdRegistrationModel.ChkPreOP = 1;
    this.IpdRegistrationModel.Billing = null;
    this.IpdRegistrationModel.NurseRemarks = 47;
    this.IpdRegistrationModel.Instruction = 46;
    this.IpdRegistrationModel.FK_CalledByID = 1;
    this.IpdRegistrationModel.Iscalled = 1;
    this.IpdRegistrationModel.tokenNo = 43;
    console.log('fesh after patiend id', this.IpdRegistrationModel);

  }


  setupdateIpdRegistrationForm(data) {

    this.PatinetName = data?.patientName;
    this.IpdRegistrationModel.PK_IPDId = data.pK_IPDId;
    this.IpdRegistrationModel.FK_BranchId = data?.fK_BranchId;
    this.IpdRegistrationModel.FK_RegId = data?.fK_RegId
    this.IpdRegistrationModel.ViaBooking = data?.viaBooking;
    this.IpdRegistrationModel.FK_ConsId = data?.fK_ConsId;
    this.IpdRegistrationModel.IPDAdmDate = data?.ipdAdmDate;
    this.IpdRegistrationModel.IPDAdmTime = data?.ipdAdmTime;
    this.IpdRegistrationModel.AgeYear = data?.ageYear;
    this.IpdRegistrationModel.AgeMonth = data?.ageMonth;
    this.IpdRegistrationModel.AgeDays = data?.ageDays;
    this.IpdRegistrationModel.Gaurdian = data?.gaurdian;
    this.IpdRegistrationModel.FK_ReferedById = data?.fK_ReferedById;
    this.IpdRegistrationModel.MLC = data?.mlc;
    this.IpdRegistrationModel.IsDischarge = data?.isDischarge;
    this.IpdRegistrationModel.DOD = data?.dod;
    this.IpdRegistrationModel.TOD = data?.tod;
    this.IpdRegistrationModel.FK_WardID = data?.fK_WardID;
    this.IpdRegistrationModel.RoomName = data?.roomName;
    this.IpdRegistrationModel.FK_PartyId = data?.fK_PartyId;
    this.ShowPartyName = this.billingservice.partytpa.filter(item => item.pkPartyId == data?.fK_PartyId)[0]?.partyName;
    this.IpdRegistrationModel.RateType = data?.rateType;
    this.IpdRegistrationModel.Remarks = data?.remarks;
    // this.IpdRegistrationModel.PK_SynchId = this.PatientObj?.pK_SynchId;
    this.IpdRegistrationModel.OLDIPDID = data?.oldipdid;
    this.IpdRegistrationModel.IsOneEyed = data?.isOneEyed;
    this.IpdRegistrationModel.FK_LocationId = data?.fK_LocationId;
    this.IpdRegistrationModel.IPDType = data?.ipdType;
    this.IpdRegistrationModel.IsDischargeApproveByDr = data?.isDischargeApproveByDr;
    this.IpdRegistrationModel.IsDischargeApproveByAdmin = data?.isDischargeApproveByAdmin;
    this.IpdRegistrationModel.ManualIPNO = data?.manualIPNO;
    this.IpdRegistrationModel.FK_CreatedById = data?.fK_CreatedById;
    this.IpdRegistrationModel.FK_ModifiedById = this.authService.Loggeduser.userid;
    this.IpdRegistrationModel.FK_CategoryId = data?.fK_CategoryId;
    this.IpdRegistrationModel.IPDNO = data?.ipdno;
    this.IpdRegistrationModel.FK_ConsultantId = data?.fK_ConsultantId;
    this.IpdRegistrationModel.FK_ConsultantID2 = data?.fK_ConsultantID2;
    this.IpdRegistrationModel.surgerydate = this.datePipe.transform(data?.surgerydate, "yyyy-MM-dd");
    this.IpdRegistrationModel.Reason = data?.reason;
    this.IpdRegistrationModel.FK_UpgradeServiceID = data?.fK_UpgradeServiceID == 0 ? null : data?.fK_UpgradeServiceID;
    this.IpdRegistrationModel.UpgradeAmount = data?.upgradeAmount;
    this.IpdRegistrationModel.IsOTConsentTaken = data?.isOTConsentTaken;
    this.IpdRegistrationModel.ClinicalApprovalComments = data?.clinicalApprovalComments;
    this.IpdRegistrationModel.FinancialApprovalComments = data?.financialApprovalComments;
    this.IpdRegistrationModel.Reinreason = data?.reinreason;
    this.IpdRegistrationModel.counseloreRemarks = data?.counseloreRemarks;
    this.IpdRegistrationModel.fK_RoomCategoryId = data?.fK_RoomCategoryId;
    if (this.IpdRegistrationModel.FK_ConsId != null) {
      this.GetCounselorAdditionalService(this.IpdRegistrationModel.RateType, this.IpdRegistrationModel.FK_ConsId, 1)
    } else {
      this.setpackageforUpdate(this.IpdRegistrationModel.PK_IPDId);
    }
    this.getBedDetail(this.IpdRegistrationModel.PK_IPDId);
    //  this.setupgradepackageforUpdate(this.IpdRegistrationModel.PK_IPDId);
    let referedby = this.opdvisitService.personmaster.filter(item => item.pkPersonId == this.IpdRegistrationModel.FK_ReferedById);
    let category = this.dashboardService.categories.filter(item => item.pkCategoryId == this.IpdRegistrationModel.FK_CategoryId);;
    let consultantName = this.DoctorListArray.filter(item => item.userId == this.IpdRegistrationModel.FK_ConsultantId);
    let consultantName2 = this.DoctorListArray.filter(item => item.userId == this.IpdRegistrationModel.FK_ConsultantID2);
    this.ShowReferdByName = referedby[0]?.personName;
    this.ShowCateName = category[0]?.categoryName;
    this.ShowDoctorName = consultantName[0]?.userName;
    this.ShowDoctorName2 = consultantName2[0]?.userName;
    let catdata = this.categoryRoomArray.filter(item => item.pK_RoomCategoryId == this.IpdRegistrationModel.fK_RoomCategoryId)
    this.roomcategoryName = catdata[0]?.roomCategory;
    this.WardListArray = this.WardListArrayfull.filter(item => item.fK_RoomCategoryId == this.IpdRegistrationModel.fK_RoomCategoryId && item.fK_BranchId == this.IpdRegistrationModel.FK_BranchId && (item.fK_IPDID == 0 || item.fK_IPDID == null));
    console.log('in case of update', this.IpdRegistrationModel);

  }



  setIpdRegistrationFormbybooking(data) {
    console.log('booking data', data);
    this.IpdRegistrationModel.PK_IPDId = 0;
    this.IpdRegistrationModel.FK_BranchId = this.authService.Loggeduser.branchid;
    this.IpdRegistrationModel.FK_RegId = this.PatientObj?.pkRegId;
    this.IpdRegistrationModel.ViaBooking = true;
    this.IpdRegistrationModel.FK_ConsId = data.pK_CounselorId;
    this.IpdRegistrationModel.FK_ConsultantId = data.fK_MainSurgeronId;
    this.IpdRegistrationModel.FK_ConsultantID2 = data.fK_CoSurgeronId;
    let consultantName = this.DoctorListArray.filter(item => item.userId == this.IpdRegistrationModel.FK_ConsultantId);
    let consultantName2 = this.DoctorListArray.filter(item => item.userId == this.IpdRegistrationModel.FK_ConsultantID2);
    this.ShowDoctorName = consultantName[0]?.userName;
    this.ShowDoctorName2 = consultantName2[0]?.userName;
    this.IpdRegistrationModel.IPDAdmDate = this.dashboardService.selecteddate;
    this.IpdRegistrationModel.IPDAdmTime = new Date().toTimeString().split(" ")[0];
    this.IpdRegistrationModel.AgeYear = this.PatientObj?.ageYear;
    this.IpdRegistrationModel.AgeMonth = this.PatientObj?.ageMonth;
    this.IpdRegistrationModel.AgeDays = this.PatientObj?.ageDays;
    this.IpdRegistrationModel.Gaurdian = ' ';
    // this.IpdRegistrationModel.FK_ReferedById = 1;
    this.IpdRegistrationModel.MLC = false;
    this.IpdRegistrationModel.IsDischarge = false;
    this.IpdRegistrationModel.DOD = null
    this.IpdRegistrationModel.TOD = null

    this.ShowPartyName = this.billingservice.partytpa.filter(item => item.pkPartyId == data?.fK_PartyId)[0]?.partyName;

    let roomdata = this.WardListArrayfull.filter(obj => obj.pK_RoomId == data.fK_WardId);
    this.IpdRegistrationModel.fK_RoomCategoryId = roomdata[0]?.fK_RoomCategoryId;
    this.roomcategoryName = this.categoryRoomArray.filter(item => item.pK_RoomCategoryId == this.IpdRegistrationModel.fK_RoomCategoryId)[0]?.roomCategory;
    this.WardListArray = this.WardListArrayfull.filter(item => item.fK_RoomCategoryId == this.IpdRegistrationModel.fK_RoomCategoryId && item.fK_BranchId == this.IpdRegistrationModel.FK_BranchId && (item.fK_IPDID == 0 || item.fK_IPDID == null));
    this.IpdRegistrationModel.FK_PartyId = data.fK_PartyId;
    if (this.WardListArray.length > 0) {
      const checkroom = this.WardListArray.filter(item => String(item.roomName).toLowerCase() == String(data?.roomName).toLowerCase());
      this.IpdRegistrationModel.RoomName = checkroom.length > 0 ? checkroom[0].roomName : null;
      this.IpdRegistrationModel.FK_WardID = checkroom.length > 0 ? checkroom[0].pK_RoomId : null;
    } else {
      this.IpdRegistrationModel.RoomName = data?.roomName;
      this.IpdRegistrationModel.FK_WardID = data.fK_WardId;
    }

    this.IpdRegistrationModel.RateType = data.rateType;
    this.IpdRegistrationModel.Remarks = '';
    // this.IpdRegistrationModel.PK_SynchId = :0;
    this.IpdRegistrationModel.OLDIPDID = '';
    this.IpdRegistrationModel.IsOneEyed = false;
    this.IpdRegistrationModel.FK_LocationId = this.PatientObj?.fkSdLocationId;
    this.IpdRegistrationModel.IPDType = '';
    this.IpdRegistrationModel.IsDischargeApproveByDr = false;
    this.IpdRegistrationModel.IsDischargeApproveByAdmin = false;
    this.IpdRegistrationModel.ManualIPNO = null;
    this.IpdRegistrationModel.FK_CreatedById = this.authService.Loggeduser.userid;
    this.IpdRegistrationModel.FK_ModifiedById = null;
    this.IpdRegistrationModel.FK_CategoryId = 1;
    this.IpdRegistrationModel.IPDNO = 0;
    this.IpdRegistrationModel.surgerydate = this.datePipe.transform(data.surgeryDate, "yyyy-MM-dd");
    this.IpdRegistrationModel.Reason = '';
    this.IpdRegistrationModel.FK_UpgradeServiceID = data.fK_UpgradeServiceID == 0 ? null : data.fK_UpgradeServiceID;
    this.IpdRegistrationModel.UpgradeAmount = null;
    this.IpdRegistrationModel.IsOTConsentTaken = null;
    this.IpdRegistrationModel.ClinicalApprovalComments = '';
    this.IpdRegistrationModel.FinancialApprovalComments = '';
    this.IpdRegistrationModel.counseloreRemarks = data.counselorRemarks;
    this.IpdRegistrationModel.Reinreason = '';
    console.log('fesh after patiend id', this.IpdRegistrationModel);
    this.GetCounselorAdditionalService(data.rateType, data.pK_CounselorId, 1);

    // this.setbookingUpgradepackaged(data.pK_CounselorId);

  }

  setbookingpackaged(a?: any, b?: any) {

    this.ipdService.getpackageById(b).pipe(takeUntil(this.destroy$)).subscribe(data => {
      this.PackageListArray = [];
      if (data) {
        data?.forEach(element => {
          this.PackageListArray.push({ "pK_TranId": 0, "discount": element.discount ? element.discount : 0, "discountPer": element.discountPer, "fK_IPDId": this.IpdRegistrationModel.PK_IPDId ? this.IpdRegistrationModel.PK_IPDId : 0, "FK_ConsID": this.IpdRegistrationModel.FK_ConsId ? this.IpdRegistrationModel.FK_ConsId : null, "fK_PackageId": element.fK_PackageId, "amount": element.amount, "packageName": element.packageName })
        });
        this.paymentDetail(this.PackageListArray, 'normal');
        //  console.log('pack1', this.PackageListArray)
      }
    }, err => {
      if (err.status == 403) {
        this.dashboardService.openSnackBar("You Don't have Permission", "OK");
      } else if (err.error.statusCode == 422) {
        this.dashboardService.openSnackBar(err.error.message, "OK");
      } else {
        this.dashboardService.openSnackBar("API Failed", "OK");
      }
    })
  }

  setbookingUpgradepackaged(a) {
    this.ipdService.getIpdbookingUpgradePackage(a).pipe(takeUntil(this.destroy$)).subscribe(data => {

      if (data) {
        data?.forEach(element => {
          this.UpgradePackageListArray.push({ "pK_TranId": element.pK_TranId, "fK_IPDId": this.IpdRegistrationModel.PK_IPDId, pK_PackageId: element.fK_PackageId, "amount": element.amount, "FK_ConsID": a, packageName: element.packageName })
        });
        this.paymentDetail(this.UpgradePackageListArray, 'upgrade')
        // console.log('upgr pack 1', this.UpgradePackageListArray)

      }
    }, err => {
      if (err.status == 403) {
        this.dashboardService.openSnackBar("You Don't have Permission", "OK");
      } else if (err.error.statusCode == 422) {
        this.dashboardService.openSnackBar(err.error.message, "OK");
      } else {
        this.dashboardService.openSnackBar("API Failed", "OK");
      }
    })
  }

  printSticker(): void {


    if (this.opdvisitService.patientdetails.pkRegId) {
      let printContents, popupWin;

      printContents = document.getElementById('content').innerHTML;
      popupWin = window.open('', '_blank', 'top=0,left=0,height=100%,width=auto');

      popupWin.document.open();
      popupWin.document.write(`
              <html>
               
            <body onload="window.print()">${printContents}
            </body>
              </html>`
      );

      popupWin.document.close();
    }
    else {
      this.dashboardService.openSnackBar("Please Select Patient", "OK");
    }


  }
  setage1(year: number, months: number, days: number, gender) {
    var combine;
    if (year > 0 && months == 0 && days == 0) {
      return year + " Yrs |" + gender;
    }
    else if (months > 0 && year == 0 && days == 0) {
      return months + " Month |" + gender;
    }
    else if (days > 0 && months == 0 && year == 0) {
      return days + " Days |" + gender;
    } else if (year > 0 && months > 0 && days == 0) {
      return year + "Yrs " + months + " Month |" + gender;
    } else if (months > 0 && days > 0 && year == 0) {
      return months + " Month " + days + " Days |" + gender;
    } else if (year > 0 && days > 0 && months == 0) {
      return year + " Yrs " + days + " Days |" + gender;
    } else if (year > 0 && months > 0 && days > 0) {
      return year + " Yrs " + months + " Month " + days + " Days |" + gender;
    }
    else {
      return "";
    }
  }

  checkTitlecase(value) {
    if (value != null && value != undefined) {
      return value = (value.length > 1) ? value[0].toUpperCase() + value.substr(1).toLowerCase() : value.toUpperCase();
    }

  }

  getToday(): string {
    return this.authService.getServerDate;
  }
  disabledlist(event) {

    if (event) {
      let checkdata = this.PackageListArray.filter(item => item.fK_PackageId == event);
      if (checkdata.length > 0) {
        return true;
      } else {
        return false;
      }
    } else {
      return false;
    }
  }
  checkdate(event) {
    console.log(event);
    let selectedDate = event;
    if (this.MinimeDate > selectedDate) {

      this.IpdRegistrationModel.surgerydate = this.MinimeDate;
      return this.dashboardService.openSnackBar("Select the Present or future date", "OK");

    }

  }
  //   selectipdId(value){
  // this.getBedDetail(value);
  //   }
  printTimeline() {

    let payload = {
      "WebReportPrintMaster": {
        "module": "IPDRegistration",
        "printOption": "IPDAdmissionSticker",
        "printType": "WebNetramReport",
        "PATIENTNAME": this.PatientObj?.initial + " " + this.PatinetName,
        "MRDNO": this.PatientObj?.pkRegId || this.PatientObj?.fK_RegId,
        "IPDNO": this.IpdRegistrationModel?.PK_IPDId,
        "ROOMNO": this.bedinformationArray[0]?.billBed,
        "PRINTDATE": this.datePipe.transform(this.authService.localDate, "dd-MM-yyyy"),
        "PrintTime": this.convertTime12Hour(this.authService.localDate),
        "PatientAge": this.PatientObj.ageYear,
        "PatientGender": this.PatientObj.sex,
        "PatientAgeAndGender": this.setage1(
          this.PatientObj?.ageYear,
          this.PatientObj?.ageMonth,
          this.PatientObj?.ageDays,
          this.PatientObj?.sex
        ),
        "IPDADMDATE": this.datePipe.transform(this.IpdRegistrationModel?.IPDAdmDate, "dd-MM-yyyy"),
        "SITE": this.bookingobj[0]?.eye,
        "IPDADMTIME": '',
        "SURGEONNAME": this.ShowDoctorName2,
        "DOCTORNAME": this.ShowDoctorName
      }

    }

    this.ipdService.GetWebReportPrint(payload).pipe(takeUntil(this.destroy$)).subscribe((x: any) => {
      if (x.length > 0) {
        let printContents, popupWin;

        printContents = x[0].printTemplate;
        popupWin = window.open('', '_blank', 'top=0,left=0,height=100%,width=auto');

        popupWin.document.open();
        popupWin.document.write(`
    <html>
     
  <body onload="window.print()">${printContents}
  </body>
    </html>`
        );

        popupWin.document.close();
      } else {
        this.dashboardService.openSnackBar("Report Template Not Set", "OK");
      }
    }, err => {
      this.dashboardService.openSnackBar("Api Failed", "OK");
    })
  }
  timecheck: any;
  convertTime12Hour(time) {
    this.timecheck = null;
    this.timecheck = this.datePipe.transform(time, "HH:mm:ss");
    if (this.timecheck != null && this.timecheck != '') {
      let hour = (this.timecheck.split(':'))[0]
      let min = (this.timecheck.split(':'))[1]
      let part = hour > 12 ? 'PM' : 'AM';

      min = (min + '').length == 1 ? `0${min}` : min;
      hour = hour > 12 ? hour - 12 : hour;
      hour = (hour + '').length == 1 ? `0${hour}` : hour;

      return (`${hour}:${min} ${part}`)
    } else {
      return null;
    }

  }

  OTconsentModel() {
    // document.getElementById("OTconsentModel").style.display = "block";
    this.otConsentDocument();
  }
  //otCOnsent call
  otConsentDocument() {
    const dialogRef = this.dialog.open(OTConsentComponent, {
      panelClass: 'full-width-dialog',
      maxWidth: '33vw',
      disableClose: true,
      width: '33%',
      data: {
        //  id: this.dashboardService.pid,
        eyetype: ''
      }

    });
    dialogRef.afterClosed().pipe(takeUntil(this.destroy$)).subscribe(result => {
    })
  }
  closeOTconsentModel() {
    document.getElementById("OTconsentModel").style.display = "none";
  }
  getOtConsent() {

    this.ipdService.getOTconstent(0, 'OTConcent').pipe(takeUntil(this.destroy$)).subscribe((x: any) => {
      this.Otconsentdata = {};
      if (x.length > 0) {
        this.Otconsentdata = x;
      }
    }, err => {
      if (err.status == 403) {
        this.dashboardService.openSnackBar("You Don't have Permission", "OK");
      } else if (err.error.statusCode == 422) {
        this.dashboardService.openSnackBar(err.error.message, "OK");
      } else {
        this.dashboardService.openSnackBar("API Failed", "OK");
      }
    })
  }

  getreport(docid, docName, doctype) {
    if (this.IpdRegistrationModel.PK_IPDId != undefined) {
      this.ipdId = this.IpdRegistrationModel.PK_IPDId;
    } else {
      this.ipdId = 0;
    }
    if (docid) {
      window.open(this.reporturl + 'SurgicalConsentmaster.aspx?DocumentId=' + docid + '&DocumentName=' + docName + '&IpdID=' + this.ipdId + '&BranchId=' + this.authService.Loggeduser.branchid + '&PageHeadWebReport=' + this.PageHeader + '&OTType=' + doctype + '&BillingCompanyName=' + this.authService.Loggeduser.billingcompanyname);
    }
    else {
      this.dashboardService.openSnackBar("Please Select Bill ", "OK");
    }


  }
  ChangeHeader(event: any) {

    if (event == true) {
      this.PageHeader = 'N';
      this.headerChecked = false;
    } else {
      this.PageHeader = 'Y';
      this.headerChecked = true;
    }
  }

  addCorporateDetail() {

    if (this.IpdRegistrationModel.PK_IPDId > 0) {
      this.ipdService.content.next({});
      const dialogRef = this.dialog.open(CorporateDetailComponent, {
        panelClass: "full-width-dialog",
        maxWidth: "100vw !important",
        height: "100%",
        width: "100%",
        data: { partyip: this.IpdRegistrationModel.FK_PartyId, ipdId: this.IpdRegistrationModel.PK_IPDId, billId: 0, }
      });

      dialogRef.afterClosed().pipe(takeUntil(this.destroy$)).subscribe(result => {
        console.log(result)

      });
    }
  }

  formattimechange(appttime: string) {
    if (appttime == null) {
    } else {
      var hr_min_sec = appttime.split(".", 2);
      var hr_min = hr_min_sec[0].split(":", 3);
      return hr_min[0] + ":" + hr_min[1];
    }
  }
}

